/**
 * Default selector used for all focusable elements.
 */
const FOCUSABLE_SELECTOR = [
    'a[href]',
    'audio[controls]',
    'button',
    'details summary',
    'input',
    'map area[href]',
    'select',
    'svg a[xlink\\:href]',
    '[tabindex]',
    'textarea',
    'video[controls]',
].map(t => t + ':not([tabindex^="-"]):not([disabled])').join()

export default {
    methods: {
        /**
         * Finds all focusable elements within and including el.
         */
        queryFocusableElements(el) {
            const elements = [...el.querySelectorAll(FOCUSABLE_SELECTOR)]
            if (el.matches(FOCUSABLE_SELECTOR)) {
                elements.unshift(el)
            }

            return elements
        },

        queryFirstFocusableElement(el) {
            return this.queryFocusableElements(el)[0]
        },
    }
}